import React from 'react';
import { observer } from 'mobx-react';
import {
  UnlockIcon,
  LockIcon,
  FitIcon,
  ZoomOutIcon,
  ZoomInIcon,
} from '../../assets/icons';
import {
  ControlsBar,
  ControlButton,
  ControlsDivider,
} from './BottomControls.styles';
import { ModifiedTooltip } from '../../../../common/components/ModifiedTooltip/ModifiedTooltip';
import { useStore } from '../../../app/data/root.store';

export const BottomControls = observer(({
  fitView,
  zoomIn,
  zoomOut,
}) => {
  const { entitiesStore } = useStore();
  
  const handleLockToggle = () => {
    entitiesStore.toggleCanvasLock();
  };

  return (
    <ControlsBar>
      <ModifiedTooltip
        title={
          entitiesStore.isCanvasLocked
            ? <>Canvas is locked.<br />Unlock to edit structure.</>
            : <>Lock canvas to prevent<br /> accidental edits.</>
        }
      >
        <ControlButton
          onClick={handleLockToggle}
          aria-label={entitiesStore.isCanvasLocked ? 'Unlock' : 'Lock'}
        >
          {entitiesStore.isCanvasLocked ? <LockIcon width={20} height={20} /> : <UnlockIcon width={20} height={20} />}
        </ControlButton>
      </ModifiedTooltip>
      <ControlsDivider />
      <ModifiedTooltip title="Fit to screen">
        <ControlButton
          onClick={() => fitView({ duration: 200, padding: 0.1 })}
          aria-label="Fit View"
        >
          <FitIcon width={20} height={20} />
        </ControlButton>
      </ModifiedTooltip>
      <ModifiedTooltip title="Zoom out">
        <ControlButton
          onClick={zoomOut}
          aria-label="Zoom Out"
        >
          <ZoomOutIcon width={20} height={20} />
        </ControlButton>
      </ModifiedTooltip>
      <ModifiedTooltip title="Zoom in">
        <ControlButton
          onClick={zoomIn}
          aria-label="Zoom In"
        >
          <ZoomInIcon width={20} height={20} />
        </ControlButton>
      </ModifiedTooltip>
    </ControlsBar>
  );
}); 